<template>
  <app-content class="h-panel">
    <div class="flex justify-between mx-16px pt-16px">
      <DropdownCustom ref="paramsDropdown" button class="h-btn-primary" trigger="click">
        <div>{{ fqFormat(params.start) }}</div>
        <template #content>
          <Form style="padding: 10px;width: 230px">
            <Form style="padding: 10px">
              <FormItem class="!pb-5px" label="会计期间">
                <Select :datas="checkoutSelect" v-model="params.start" :deletable="false"/>
              </FormItem>
            </Form>
            <FormItem class="!pb-5px">
              <vxe-button status="primary" @click="loadList();" :loading="loading">确定</vxe-button>
              <vxe-button @click="this.$refs.paramsDropdown.hide()">取消</vxe-button>
              <!-- <vxe-button @click="reset">重置</vxe-button> -->
            </FormItem>
          </Form>
        </template>
      </DropdownCustom>
      <div class="float-right flex items-center">
        <vxe-button @click="loadList" icon="fa fa-print" content="刷新"/>
        <vxe-button @click="exportData" icon="fa fa-download" content="导出"/>
        <vxe-button @click="printData" icon="fa fa-print" content="打印"/>
      </div>
    </div>
    <div class="text-center mb-16px font-bold text-20px">{{ title }} 应付分析表</div>
    <div class="h-panel-body">
      <vxe-table 
                 show-footer
                 :footer-method="calcTotal"
                 :loading="loading" ref="xTable" :data="dataList" border >
        <vxe-column title="客户" field="name" align="left" tree-node width="12.5%"></vxe-column>
        <vxe-column title="期初" field="begin" align="right" width="12.5%" formatter="toMoney"></vxe-column>
        <vxe-column title="本期发生" field="credit" align="right" width="12.5%" formatter="toMoney"/>
        <vxe-column title="本期支付" field="debit" align="right"  width="12.5%" formatter="toMoney"/>
        <vxe-column title="余额" field="end" align="right"  width="12.5%" formatter="toMoney"/>
        <vxe-column title="本年发生" field="yearCredit" align="right"  width="12.5%" formatter="toMoney"/>
        <vxe-column title="本年支付" field="yearDebit" align="right"  width="12.5%" formatter="toMoney"/>
      </vxe-table>
    </div>
  </app-content>
</template>

<script>
import BooUtil from "@/views/accountbook/bookUtil";
import accountbook from "@/api/accountbook";
import {downloadBlob} from "download.js";
import manba from "manba";
import {mapGetters, mapState} from "vuex";
import AccountDateRangeChoose from "@/components/AccountDateRangeChoose";
import {clone} from "xe-utils";
import setting from "@/api/setting";

export default {
  name: "ApAnalysis",
  components: {AccountDateRangeChoose},
  data() {
    return {
      subjectList: [],
      dataList: [],
      accountDate: null,
      loading: false,
      params: {
        start: null,
      },
      tablePrint: {
        // 自定义打印的样式示例
        style: `
          /* 整个表格的基础样式 */
          .vxe-table {
            font-family: "Microsoft YaHei", 微软雅黑, "MicrosoftJhengHei", 华文细黑, STHeiti, MingLiu; // 设置表格整体字体
          }

          /* 表头单元格 */
          .vxe-table thead th {
            border: 1px solid #000;
            font-size: 14px;
            word-break: break-all;
            overflow-wrap: break-word;
          }

          /* 表体单元格（即数据行的所有单元格） */
          .vxe-body--column, 
          .vxe-table tbody td {
            border: 1px solid #000;
            font-size: 12px;
            word-break: break-all;
            overflow-wrap: break-word;
          }
          /* 表尾单元格样式 */
          .vxe-table tfoot td {
            border: 1px solid #000;
            font-size: 12px;
          }
        `,
        beforePrintMethod: ({ content }) => {
          const headerHtml = `<h3>应付分析表</h3>
            <div style="display:flex;justify-content: space-between;height:22px;line-height:22px">
                <span>编制单位：${this.currentAccountSets.companyName}</span>
                <span> ${this.title} </span>
                <span> 单位：元 </span>
            </div>
          `;
          const footerHtml = ``;
          return `${headerHtml}${content}${footerHtml}`;
        },
      },
    }
  },
  computed: {
    ...mapState(['currentAccountSets']),
    ...mapGetters(['checkoutSelect', 'localCurrency']),
    title() {
			if (!this.params.start) {
				return '';
			}
			return manba(this.params.start).format("YYYY年MM期")
		},
    topData() {
      return this.dataList;
    }
  },
  watch: {
    accountDate() {
      this.loadList();
    },
  },
  methods: {
    dateCheck(){
      // 定义开始时间和结束时间
      let startDate = new Date(this.params.start);
      let endDate = new Date(this.params.end);
      if(startDate > endDate){
        this.$Message({
          type:'warn',
          text: `开始时间必须早于或等于结束时间！`
        });
      }
    },
    processFilter() {
      this.$nextTick(() => {
        const isBalanceZeroAndOccur = this.isBalanceZeroAndOccur;
        const isBalanceZero = this.isBalanceZero;
        let filterFn;
        if (isBalanceZeroAndOccur) {
          filterFn = val => val.debit != 0 || val.credit != 0 || val.endBalance != 0;
        } else if (isBalanceZero) {
          filterFn = val => val.endBalance != 0;
        } else {
          return this.loadList();
        }
        const filteredDataList = this.dataList.filter(filterFn);
        this.dataList = filteredDataList;
      });
    },
    printData() {
      // 获取VXE-Table实例
      const xTable = this.$refs.xTable;
      // 调用打印方法，并传入打印配置
      xTable.print({
        ...this.tablePrint,
      });
    },
    loadList() {
      this.loading = true;
      accountbook.loadApAnalysis(this.params).then(({data}) => {
        this.loading = false;
        this.dataList = data;
        this.$refs.paramsDropdown.hide();
      });
    },
    sfilter(item, val) {
      return item.code.indexOf(val) !== -1 || item.name.indexOf(val) !== -1 || item.mnemonicCode.indexOf(val) !== -1;
    },
    exportData() {
      const utils = new BooUtil(this.$refs.xTable, '\n')
      accountbook.download({header: utils.header, dataList: utils.dataList}).then((data) => {
        downloadBlob(`${this.title}-应付分析表.xls`, data)
      })
    },
    resetForm() {
      this.params = clone(this.cloneParams, true)
    },
    calcTotal({columns, data}) {
      const row = [];
      columns.forEach(col => {
        if ('begin' === col.property) {
          // row.push(this.numFormat(this.topData.filter(val => val.balanceDirection === '借').reduce((total, r) => total + (r.beginBalance || 0), 0)));
          row.push(this.numFormat(this.topData.reduce((total, r) => total + (r.begin || 0), 0)));
        } else if (!['subjectCode', 'name'].includes(col.property)) {
          row.push(this.numFormat(this.topData.reduce((total, r) => total + (r[col.property] || 0), 0)));
        } else {
          row.push(col.property === "name" ? '合计' : "")
        }
      })
      return [row];
    }
  },
  created() {
    this.params.start = manba(this.currentAccountSets.currentAccountDate).format("YYYY-M");
    this.params.currencyId = this.localCurrency.id;
    this.cloneParams = clone(this.params, true)
    this.loadList();
  }
}
</script>

<style scoped lang="less">
.balance {
  width: 100%;
  border-collapse: collapse;

  td {
    padding: 0 8px;
    border: 1px solid #e2e2e2;
    font-size: 12px;
    height: 32px;

    &.tip {
      background-color: #FFEEEF;
    }
  }

  tbody tr:nth-child(even) {
    background-color: #f8fbf8;
  }

  tbody tr:hover {
    background-color: #F0F6FF;
  }

  .header {
    td {
      background-color: #F5F5F5;
      text-align: center;
      font-weight: bold;
      height: 35px;
    }
  }
}
</style>
